import { useBlogTableOfContents } from "@/hooks/useBlogTableOfContents";
import { BlogSection } from "@/data/blogPosts";

interface BlogTableOfContentsProps {
  sections: BlogSection[];
}

const BlogTableOfContents = ({ sections }: BlogTableOfContentsProps) => {
  const tocItems = sections.map((section) => ({
    id: section.id,
    title: section.tocTitle ?? section.title,
  }));

  const { activeId, scrollToSection } = useBlogTableOfContents(tocItems);

  if (sections.length === 0) return null;

  return (
    <nav className="bg-secondary/30 rounded-xl p-6">
      <h3 className="font-semibold text-foreground mb-4">Inhaltsverzeichnis</h3>
      <ul className="space-y-2">
        {tocItems.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => scrollToSection(item.id)}
              className={`block w-full text-left px-3 py-2 text-sm rounded-lg transition-all ${
                activeId === item.id
                  ? "bg-accent/10 text-accent font-medium border-l-2 border-accent"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
              }`}
            >
              {item.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BlogTableOfContents;
